import { createBrowserRouter } from "react-router-dom";
import Homepage from "../components/Homepage";
import Projects from "../components/Projects";
import Certification from "../components/Certification";
import Contact from "../components/Contact";

export const router = createBrowserRouter([
  //   HOME ROUTE
  {
    path: "",
    children: [
      { path: "/", element: <Homepage /> },
      { path: "/projects", element: <Projects /> },
      { path: "/certification", element: <Certification /> },
      { path: "/contact", element: <Contact /> },
    ],
  },
]);
